import { useRef } from 'react';

import { Divider } from '@material-ui/core';

import useSWR from 'swr';

import { Section, SectionAlternate } from '@/src/components/organisms';
import { scroller } from '@/src/lib/utils';

import { Contact, Solutions, Hero, Partners, Reviews, Features } from './components';
import { institutions, sellers, families, features, reviews } from './data';

function SolutionsView() {
  const solutionsRef = useRef();

  const scrollToRef = ref => setTimeout(() => scroller(ref.current.offsetTop - 200), 500);

  const { data: partners } = useSWR('/commons/cms/institutions/');

  return (
    <div>
      <Section>
        <Hero onLearnMore={() => scrollToRef(solutionsRef)} />
      </Section>
      <Divider />
      <Section>
        <Partners institutions={partners} />
      </Section>
      <Divider />
      <Section>
        <div ref={solutionsRef}>
          <Solutions
            title="Soluções para consumidores educacionais"
            subtitle="Responsáveis financeiros de alunos de instituições de ensino, próprios alunos ou até mesmo empresas que consumam produtos ou serviços educacionais."
            data={families}
          />
        </div>
      </Section>
      <Divider />
      <Section>
        <Solutions
          title="Soluções para instituições de ensino"
          subtitle="Qualquer instituição de ensino que precise vender online para seus alunos ou responsáveis"
          data={institutions}
          demo="/"
        />
      </Section>
      <Divider />
      <Section>
        <Solutions
          title="Soluções para fornecedores educacionais"
          subtitle="Empresas que fornecem produtos ou serviços educacionais e precisem vender online diretamente para os consumidores finais ou próprias instituições de ensino"
          data={sellers}
          demo="/"
        />
      </Section>
      <Divider />
      <SectionAlternate>
        <Features data={features} />
      </SectionAlternate>
      <Section>
        <Reviews data={reviews} />
      </Section>
      <SectionAlternate>
        <Contact />
      </SectionAlternate>
    </div>
  );
}

export default SolutionsView;
